import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { trackEvent as TRACK_EVENT } from '@admiin-com/ds-graphql';

export const useMixpanel = () => {
  const [trackMutation] = useMutation(gql(TRACK_EVENT));

  const track = useCallback(
    async (event: string, properties?: Record<string, unknown>) => {
      await trackMutation({
        variables: {
          input: {
            event,
            properties: properties ? JSON.stringify(properties) : undefined,
          },
        },
      });
    },
    [trackMutation]
  );

  return { track };
};
